<mat-label class="subHeading">Business Type<span *ngIf="isRequired" class="star">*</span></mat-label>
<mat-select formControlName="business_type" class="business" placeholder="{{isRequired ? 'Select' : 'All'}}" multiple>
    <button
        *ngIf="isMultiSelect"
        class="btn selectAll"
        (click)="selectAll()"
    >
        Select All
    </button>
    <button
        *ngIf="isMultiSelect"
        class="btn selectAll"
        (click)="unSelectAll()"
    >
        Remove All
    </button>
    <mat-option (onSelectionChange)="selectionChange($event)" *ngFor="let businessType of businessTypes" [value]="businessType">{{businessType.replaceAll('_', ' ') | titlecase}}</mat-option>
</mat-select>